module.exports = __webpack_public_path__ + "a4cc970b1be8759bdb93f048279ce378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-8.jpg
// module id = 82
// module chunks = 0